/**
 * Le texte d'un HTML leger (commentaire de la fiche adherent), sans sa
 * mise en forme : pour l'export Excel. Le navigateur fait l'analyse —
 * un paragraphe ou un saut de ligne devient un retour a la ligne.
 */
export function texteDepuisHtml(html: string | null | undefined): string {
  if (!html) return '';
  const document = new DOMParser().parseFromString(
    html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n'),
    'text/html',
  );
  return (document.body.textContent ?? '').replace(/\n{2,}/g, '\n').trim();
}
